import Error from '../model/Error';
import TrainingReply from '../dto/offering/TrainingReply';
import axios from 'axios';
import moment from 'moment';

export default class TrainingReplyRepository {
    static getReplies(appointmentSeriesId, start) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/training-offering-replies/appointment/${appointmentSeriesId}/${start}`)
                .then((response) => resolve(response.data.data.map((data) => TrainingReply.fromData(data))))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static createResponse(clubId, memberId, appointment, response = TrainingReply.RESPONSE_ACCEPTED) {
        return new Promise((resolve, reject) => {
            axios
                .post(`/club/clubs/${clubId}/training-offering-replies`, {
                    appointmentSeriesId: appointment.appointmentSeries.id,
                    start: moment(appointment.start.date, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm'),
                    memberId,
                    response,
                })
                .then((response) => resolve(response.data.data))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
